// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__G0E9e","description":"PatientConsentPreview_description__2UJQo"};